import React, { useEffect } from "react";
import styles from "./MenuTabs.module.css";
import PropTypes from "prop-types";
import { RouterName } from "shared/RouterName";

import { TabItem } from "components/Menu";
import { useDispatch, useSelector } from "react-redux";
import { fetchListCategoryParentRequest } from "redux/ActionCreators/CategoryParentActionCreator";
import Button from "@material-ui/core/Button";
import HomeIcon from "@material-ui/icons/Home";
import history from "core/helper/Helper";

const MenuTabs = (props) => {
  const dispatch = useDispatch();

  const categoriesParent = useSelector((state) => state.categoriesParent.list);

  useEffect(() => {
    dispatch(fetchListCategoryParentRequest());
  }, []);

  return (
    <div className={styles.container}>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        color={"primary"}
        size="large"
        className={styles.btn_menu}
        startIcon={<HomeIcon />}
        onClick={() => history.push(RouterName.HomePage.url)}
      >
        Trang Chủ
      </Button>
      {categoriesParent &&
        categoriesParent.map((item, index) => (
          <TabItem key={index} item={item} />
        ))}
    </div>
  );
};

MenuTabs.propTypes = {
  variant: PropTypes.string.isRequired,
  orientation: PropTypes.string.isRequired,
};

export default MenuTabs;
